export default "__VITE_ASSET__3d162555__"